import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import TutorList from "../components/TutorList";

const TutorListPage = () => {
    return (
        <>

<div className="d-flex justify-content-between"><h5>Tutors  </h5><Breadcrumb title="Tutors" /></div>

        <TutorList/>

        </>
    );
}
export default TutorListPage;